import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

const services = [
  { icon: "pi pi-file", label: "HCT E-consent" },
  { icon: "pi pi-user-plus", label: "Doctor at Home" },
  { icon: "pi pi-home", label: "Home Health Care" },
  { icon: "pi pi-flask", label: "Home Lab Test" },
  { icon: "pi pi-heart", label: "Nursing Care at Home" },
  { icon: "pi pi-clinic-medical", label: "PCR at Home" },
  { icon: "pi pi-users", label: "Paediatric at Home" },
  { icon: "pi pi-star", label: "Physiotherapy at Home" },
  { icon: "pi pi-plus-circle", label: "Vitamin IV Drops" },
];

const BookMedicalService = () => {
  const navigate = useNavigate();

  const handleServiceClick = (serviceLabel) => {
    const stored = localStorage.getItem("userDetails");
    navigate(stored ? "/service-booking" : "/login");
  };

  return (
    <div className="bms-container">
      <div className="bms-content">
        {/* Left Column */}
        <div className="bms-left">
          <h2 className="bms-heading">Book</h2>
          <h1 className="bms-title">Medical Services</h1>
          <p className="bms-subtitle">
            Get quick access to all other medical services suiting your health
            needs.
          </p>
          <Button
            label="See More"
            className="p-button-rounded p-button-primary"
          />
        </div>

        {/* Right Column */}
        <div className="bms-grid">
          {services.map((s, i) => (
            <div
              key={i}
              className="bms-card"
              onClick={() => handleServiceClick(s.label)}
            >
              <i className={`pi ${s.icon} bms-icon`} />
              <div className="bms-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BookMedicalService;
